import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class BaseServiceService {

//Url:string = environment.baseUrl;
Url:string = "";
public window = window;

  constructor() {
    switch (this.window.location.host) {
      case "localhost:8100":
        this.Url = environment.baseUrl;
        break;
      case "localhost":
        this.Url = environment.baseUrl;
        break;
      case "localhost:4200":
        this.Url = environment.baseUrl;
        break;
      case "localhost:5500":
        this.Url = environment.baseUrl;
        break;

      default:
        this.Url = window.location.protocol + "//" + this.window.location.host;
        break;
    }
    
    //console.log(this.Url);
  }

  baseUrl(){
    return this.Url + '/stbetrest/services/online/';
  }

  envUrl(){
    return this.Url;
  }
}
